import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import ProfileTitle from '../../../../../layout/mobile/profile/ProfileTitle';
import IssuesList from '../IssuesList';

const IssuesMobile = ({ ...props }) => {
  const { issues, product, loading, error } = props;
  return (
    <Box marginTop="24px">
      <ProfileTitle mobile title="Reportar inconveniente" />
      <IssuesList
        issues={issues}
        mobile={true}
        product={product}
        loading={loading}
        error={error}
      />
    </Box>
  );
};

IssuesMobile.propTypes = {
  issues: PropTypes.array,
  product: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

export default IssuesMobile;
